import { ProtectedRoute } from '@common-web/index.js';
import {
  ACCESS_DENIED,
  ACCOUNT_STATEMENT_DETAIL,
  ACCOUNT_STATEMENT_FINANCE,
  ADD_ROLES,
  ADD_SELLER_PATH,
  ADVANCE_PAYMENT_PATH,
  ALL_IMAGES_PATH,
  CALLS_PATH,
  CARTS,
  CATEGORIES_MODERATION_PATH,
  CATEGORY_MODERATION_DETAIL,
  CP_PATH,
  DASHBOARD_PATH,
  EDIT_PRODUCT_CP,
  EDIT_SELLER_PATH,
  LOCATIONS_PATH,
  LOGIN_PATH,
  MANAGE_ROLES,
  NOT_FOUND,
  ORDER_OVERVIEW_FINANCE,
  ORDERS_LISTING_PATH,
  ORDERS_PATH,
  ORDER_DETAIL_PATH,
  PRODUCT_IMAGES,
  PRODUCTS_PATH,
  REAL_TIME_STATS_PATH,
  RETURN_ORDERS_PATH,
  REVIEWS,
  ROLES_PATH,
  SALES_REPORT_PATH,
  SELLERS_LISTING_PATH,
  SERVER_ERROR,
  TASKS_PATH,
  TODO_PATH,
  TYPE_MODERATION_DETAIL,
  TYPE_MODERATION_PATH,
  UPLOADS_MODERATION_PATH,
  USERS_PATH,
  WEIGHT_MODERATION_DETAIL,
  WEIGHT_MODERATION_PATH,
  FOLLOW_UPS_PATH,
  SELLER_APPEALS_PATH,
} from '@constants/cp-paths.js';
import StoreUploads from 'pages/cp/moderation/store-uploads/index.jsx';
import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';
import {
  AccountStatement,
  AccountStatementDetails,
  AddSellers,
  AdvancePayment,
  AllImagesCp,
  CallsList,
  Carts,
  CategoriesModeration,
  CategoryModerationDetail,
  Dashboard,
  EditProduct,
  LocationSettingsList,
  Login,
  ManageRoles,
  ManageUsersCp,
  OrderOverview,
  // ReplicaProduct,
  Orders,
  OrderDetail,
  ProductImages,
  Products,
  RealTimeStats,
  ReturnOrders,
  // PublishProduct,
  Reviews,
  RolesScreen,
  SalesReport,
  Sellers,
  SellerAppeals,
  TypeModeration,
  TypeModerationDetail,
  WeightModeration,
  WeightModerationDetail,
  FollowUps,
} from '../pages/cp/index.js';
// import { PUBLISH_PRODUCT } from '@constants/cp-paths.js';
// import { UNMAPPED_PRODUCTS_PATH } from '@constants/cp-paths.js';
import { AccessDenied, NotFound, ServerError } from '../pages/seller-center/index.js';

const CpRoutes = () => {
  const { authorize, redirect } = useSelector((state) => state.cpUserData);

  return (
    <Routes>
      <Route path={LOGIN_PATH} element={<Login user={authorize} />} />
      <Route path={CP_PATH} element={<ProtectedRoute user={authorize} redirect={redirect} />}>
        <Route exact path={CP_PATH} element={<Navigate to={DASHBOARD_PATH} />} />
        <Route path={DASHBOARD_PATH} element={<Dashboard />} />
        <Route path={SELLERS_LISTING_PATH} element={<Sellers />} />
        <Route path={ORDERS_LISTING_PATH} element={<Orders />} />
        <Route path={SELLER_APPEALS_PATH} element={<SellerAppeals />} />
        <Route path={ORDER_DETAIL_PATH} element={<OrderDetail />} />
        <Route path={ADVANCE_PAYMENT_PATH} element={<AdvancePayment />} />
        <Route path={RETURN_ORDERS_PATH} element={<ReturnOrders />} />
        <Route path={CARTS} element={<Carts />} />
        <Route path={PRODUCTS_PATH} element={<Products />} />
        <Route path={EDIT_PRODUCT_CP} element={<EditProduct />} />
        <Route path={PRODUCT_IMAGES} element={<ProductImages />} />
        {/* <Route path={UNMAPPED_PRODUCTS_PATH} element={<ReplicaProduct />} /> */}
        <Route path={ADD_SELLER_PATH} element={<AddSellers key={ADD_SELLER_PATH} />} />
        <Route path={EDIT_SELLER_PATH} element={<AddSellers key={EDIT_SELLER_PATH} />} />
        <Route path={CATEGORIES_MODERATION_PATH} element={<CategoriesModeration />} />
        <Route path={CATEGORY_MODERATION_DETAIL} element={<CategoryModerationDetail />} />
        <Route path={UPLOADS_MODERATION_PATH} element={<StoreUploads />} />
        <Route path={TYPE_MODERATION_PATH} element={<TypeModeration />} />
        <Route path={TYPE_MODERATION_DETAIL} element={<TypeModerationDetail />} />
        <Route path={WEIGHT_MODERATION_PATH} element={<WeightModeration />} />
        <Route path={WEIGHT_MODERATION_DETAIL} element={<WeightModerationDetail />} />
        <Route path={REVIEWS} element={<Reviews />} />
        {/* <Route path={EDIT_REVIEW} element={<EditReview />} /> */}
        {/* <Route path={EDIT_SELLER_COMMENT} element={<EditSellerComment />} /> */}
        <Route path={ORDER_OVERVIEW_FINANCE} element={<OrderOverview />} />
        <Route path={ACCOUNT_STATEMENT_FINANCE} element={<AccountStatement />} />
        <Route path={ACCOUNT_STATEMENT_DETAIL} element={<AccountStatementDetails />} />
        <Route path={ROLES_PATH} element={<RolesScreen />} />
        <Route path={CALLS_PATH} element={<CallsList />} />
        <Route path={SALES_REPORT_PATH} element={<SalesReport />} />
        <Route path={LOCATIONS_PATH} element={<LocationSettingsList />} />
        <Route path={MANAGE_ROLES} element={<ManageRoles />} />
        <Route path={ADD_ROLES} element={<ManageRoles />} />
        <Route path={USERS_PATH} element={<ManageUsersCp />} />
        <Route path={NOT_FOUND} element={<NotFound />} />
        <Route path={SERVER_ERROR} element={<ServerError />} />
        <Route path={ACCESS_DENIED} element={<AccessDenied />} />
        {/* <Route path={PUBLISH_PRODUCT} element={<PublishProduct />} /> */}
        <Route path={ALL_IMAGES_PATH} element={<AllImagesCp />} />
        <Route path={REAL_TIME_STATS_PATH} element={<RealTimeStats />} />
        <Route path={FOLLOW_UPS_PATH} element={<FollowUps />} />
        <Route path="*" element={<Navigate to={NOT_FOUND} />} />
      </Route>
      <Route path="*" element={<Navigate to={DASHBOARD_PATH} />} />
    </Routes>
  );
};

export default CpRoutes;
